import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobangalorecab() {



  const cardData =
  {
    keyword: 'Pune to Bangalore Cab',
    heading: 'Sai Trupti Cabs: Pune to Bangalore Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Bangalore cab hire services, designed to make your long-distance journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Bangalore. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Bangalore convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Bangalore with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is Bangalore’s green crown jewel — a 240-acre paradise that blooms with exotic flora from around the world. Commissioned by Hyder Ali in the 18th century and later expanded by Tipu Sultan, it houses over 1,800 species of plants and centuries-old trees. The majestic Glass House, inspired by London’s Crystal Palace, hosts the city’s famous flower shows every Republic and Independence Day. Walking through Lalbagh feels like stepping into nature’s art gallery, where lotus ponds, bonsai gardens, and rare orchids breathe life into the city. Early mornings here are filled with birdsong and soft sunlight, making it Bangalore’s most serene escape."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park lies at the heart of Bangalore, offering over 300 acres of lush greenery amidst the city’s fast pace. Established in 1870 by Sir Mark Cubbon, the park is a soothing haven for morning walkers, nature enthusiasts, and history lovers alike. Lined with bamboo groves, flowering trees, and elegant colonial buildings, it offers tranquility in every corner. The red-brick State Central Library and bandstand add old-world charm to the surroundings. Whether you’re reading under a rain tree or cycling along the shaded paths, Cubbon Park reminds visitors why Bangalore is called the 'Garden City of India'."
  },
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace stands as a majestic symbol of royal elegance and colonial heritage. Built in 1878 by Chamaraja Wadiyar, its Tudor-style architecture with fortified towers, Gothic windows, and grand ballrooms evokes the charm of medieval England. The palace interiors feature intricate wood carvings, stained glass, and portraits of royal lineage. Visitors can explore the royal courtyard, private chambers, and the hall that once hosted regal ceremonies. Surrounding gardens and open lawns host concerts and cultural events today. Stepping into Bangalore Palace feels like entering a bygone era where art, luxury, and history unite in regal harmony."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is not just an architectural wonder but a proud emblem of Karnataka’s democracy. Completed in 1956, this massive granite structure houses the State Legislature and Secretariat. Its neo-Dravidian design features grand staircases, majestic domes, and intricate stonework that represent the state’s cultural richness. Illuminated beautifully at night, the building radiates dignity and power. The inscription 'Government Work is God’s Work' on its façade reflects the philosophy of service through governance. Visitors often pause here for photography or to admire its monumental symmetry. Vidhana Soudha captures Bangalore’s spirit — progressive yet deeply rooted in tradition."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "Perched on the hillock of Rajajinagar, ISKCON Temple is one of the largest and most magnificent Krishna temples in India. Built in 1997, its gleaming white and gold architecture blends traditional South Indian temple design with modern aesthetics. The temple complex includes shrines for Lord Krishna and Radha, Bhaktivedanta Hall, and a beautifully lit courtyard. Visitors are greeted by devotional music, chants of 'Hare Krishna', and serene fountains. Beyond prayer, it promotes culture, vegetarianism, and spiritual education. From its hilltop vantage, the temple offers panoramic views of the city and a deep sense of peace amid urban chaos."
  },
  {
    "title": "Tipu Sultan’s Summer Palace",
    "description": "Tipu Sultan’s Summer Palace is a historical gem nestled in the heart of Bangalore, reflecting Indo-Islamic architectural brilliance. Constructed entirely from teakwood, it served as Tipu Sultan’s summer retreat in the late 18th century. The palace’s ornate arches, balconies, and floral motifs showcase delicate craftsmanship and royal finesse. Inside, small museums display Tipu’s personal belongings and paintings depicting his valor against the British. The palace gardens and courtyards radiate calm and elegance, transporting visitors back to the Mysorean Empire’s golden age. A visit here offers a blend of history, art, and quiet nostalgia."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Just 22 km from the city, Bannerghatta National Park is Bangalore’s natural sanctuary — home to tigers, elephants, lions, and butterflies. Spread over 100 square kilometers, it offers safaris through forested enclosures, a zoo, and India’s first Butterfly Park. Nature lovers can trek through lush trails, visit the rescue center, or enjoy boating amid greenery. The park’s wildlife education and eco-tourism efforts make it both thrilling and meaningful. Families and photographers adore this escape from city life. Bannerghatta blends adventure and conservation, reminding visitors of nature’s grandeur just a short drive from Bangalore."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake, one of Bangalore’s oldest and largest water bodies, spreads across 50 hectares near MG Road. Built by Kempegowda II in the 16th century, it’s dotted with small islands that shimmer under the sun. Boating on the calm waters offers a refreshing view of the skyline framed by trees and temple spires. The lake’s walking paths are ideal for early-morning jogs or peaceful evening strolls. During the annual Ganesha festival, the lake becomes a focal point of devotion and festivity. Ulsoor Lake captures the softer, romantic side of Bangalore — tranquil, reflective, and timeless."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s bustling shopping paradise — a colorful maze of fashion boutiques, jewelry stores, and street vendors. From ethnic wear to trendy western outfits, it’s a treasure trove for every kind of shopper. The aroma of local snacks and the chatter of bargaining create a lively urban symphony. The nearby MG Road and Brigade Road add to the city’s cosmopolitan vibe. Whether you’re hunting for souvenirs or simply soaking in the energy, Commercial Street showcases Bangalore’s youthful spirit and love for style. It’s where tradition meets modern chic under one neon glow."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills, located about 60 km from Bangalore, is a breathtaking hill fortress that once served as Tipu Sultan’s summer retreat. At 1,478 meters above sea level, it offers stunning sunrise views above drifting clouds and endless greenery. The hill is dotted with ancient temples, viewpoints like Tipu’s Drop, and serene trails that wind through misty pines. Adventure enthusiasts enjoy cycling and paragliding here. As the early morning mist clears, you can see the entire city spread out like a painting below. Nandi Hills is Bangalore’s favorite getaway — where the air feels lighter, fresher, and full of magic."
  }
],



"services": [
  {
    "name": "Pune to Bangalore Cab",
    "description": "Book comfortable Pune to Bangalore cabs for a seamless journey. Choose from AC and non-AC vehicles, including Sedans, SUVs, and luxury cars. Enjoy professional drivers experienced in long-distance travel, flexible pickup and drop points, and transparent pricing. Ideal for family trips, weekend getaways, group travel, or business trips, with easy online booking and 24/7 support ensuring a safe and enjoyable ride."
  },
  {
    "name": "Pune to Bangalore Taxi Service",
    "description": "Hire a Pune to Bangalore taxi for a smooth, stress-free ride. Travel in well-maintained vehicles with courteous drivers, enjoy flexible schedules, one-way or round-trip options, and transparent fare policies. Perfect for travelers seeking convenience, safety, and comfort on their interstate journey."
  },
  {
    "name": "Pune to Bangalore Car Hire",
    "description": "Rent a car from Pune to Bangalore for a personalized travel experience. Choose from a variety of cars including Sedans, SUVs, and luxury options. Benefit from professional drivers, luggage assistance, flexible routes, and AC/non-AC options. Ideal for family trips, group outings, or business travel with complete comfort and reliability."
  },
  {
    "name": "AC Cab Pune to Bangalore",
    "description": "Travel in comfort with AC cab service from Pune to Bangalore. Enjoy air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth travel. Suitable for families, couples, and tourists looking for a cool, relaxing journey across long distances."
  },
  {
    "name": "Non AC Cab Pune to Bangalore",
    "description": "Affordable non-AC cab service from Pune to Bangalore for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure a safe, comfortable, and cost-effective long-distance ride."
  },
  {
    "name": "Innova Cab Pune to Bangalore",
    "description": "Book spacious and comfortable Innova cabs from Pune to Bangalore. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth and relaxing travel on highways and city roads."
  },
  {
    "name": "Ertiga Cab Pune to Bangalore",
    "description": "Affordable group travel with Ertiga cabs from Pune to Bangalore. Enjoy AC/non-AC options, comfortable seating, luggage space, and professional drivers for a safe and enjoyable journey. Perfect for friends, family, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Bangalore",
    "description": "Travel in style with luxury cab service from Pune to Bangalore. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, corporate executives, or honeymoon trips. Experience comfort, safety, and prestige on your journey."
  },
  {
    "name": "Affordable Cab Pune to Bangalore",
    "description": "Get pocket-friendly Pune to Bangalore cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families."
  },
  {
    "name": "Pune to Bangalore Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Bangalore for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers, ensuring a hassle-free interstate journey."
  },
  {
    "name": "Pune to Bangalore One Way Cab",
    "description": "Book one-way cabs from Pune to Bangalore at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it perfect for travelers heading to Bangalore without return plans."
  },
  {
    "name": "Pune to Bangalore Drop Cab",
    "description": "One-way drop cab service from Pune to Bangalore with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride ideal for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Bangalore",
    "description": "Premium corporate cab hire from Pune to Bangalore with executive vehicles, professional chauffeurs, and flexible schedules. Ideal for business meetings, conferences, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Bangalore",
    "description": "Elegant wedding cab service from Pune to Bangalore with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Bangalore",
    "description": "Book your Pune to Bangalore cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute plans, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Bangalore Cab", "Pune to Bangalore Taxi Service"],
  ["Pune to Bangalore Car Hire", "AC Cab Pune to Bangalore"],
  ["Non AC Cab Pune to Bangalore", "Innova Cab Pune to Bangalore"],
  ["Ertiga Cab Pune to Bangalore", "Luxury Cab Pune to Bangalore"],
  ["Affordable Cab Pune to Bangalore", "Pune to Bangalore Outstation Cab"],
  ["Pune to Bangalore One Way Cab", "Pune to Bangalore Drop Cab"],
  ["Online Cab Booking Pune to Bangalore", "Corporate Cab Pune to Bangalore"],
  ["Wedding Cab Pune to Bangalore", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Bangalore Cab",
    "WhyChoosedescription": "Sai Trupti Cabs offers dependable and comfortable cab services from Pune to Bangalore — perfect for long-distance business trips, family travel, and intercity commutes."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy clearly defined and affordable fares for Pune to Bangalore cabs — with no hidden costs, fuel surcharges, or surprise fees."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars depending on your comfort preference, budget, and group size for the Pune–Bangalore journey."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are experienced with long-distance routes like Pune to Bangalore, ensuring safe, timely, and smooth travel."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from any location in Pune — including homes, offices, or the airport — and drop-offs anywhere in Bangalore as per your convenience."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All Sai Trupti cabs are regularly serviced, cleaned, and sanitized to make your long Pune–Bangalore journey comfortable and hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated customer support is available 24/7 to help you with bookings, travel updates, and assistance throughout your trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Bangalore cab easily via call, WhatsApp, or our website — with instant confirmation and on-time cab availability."
  }
]






















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Bangalore cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and comfortable Pune to Bangalore cab services for one way, round trips, and corporate travel needs.',
  },
  {
    question: 'How can I book a Pune to Bangalore cab with Sai Trupti Cabs?',
    answer: 'You can book your Pune to Bangalore cab easily through our website, mobile app, or by calling our 24×7 customer support team for instant assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Bangalore?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit individual, family, and group travel needs.',
  },
  {
    question: 'Are the drivers experienced for Pune to Bangalore routes?',
    answer: 'Yes, all our drivers are well-trained, professional, and experienced in long-distance routes like Pune to Bangalore, ensuring a smooth and safe journey.',
  },
  {
    question: 'Can I hire a cab for Bangalore sightseeing after reaching there?',
    answer: 'Certainly. Sai Trupti Cabs offers full-day and local sightseeing cab packages in Bangalore for popular attractions like Lalbagh, Cubbon Park, and Bannerghatta National Park.',
  },
  {
    question: 'Is the Pune to Bangalore cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Bangalore cab services, so you can start your journey at any time that suits your schedule.',
  },
  {
    question: 'What are the Pune to Bangalore cab fares?',
    answer: 'Our Pune to Bangalore cab fares start from ₹7,500 for sedans and ₹9,000–₹11,000 for SUVs or Innova Crysta, depending on your vehicle choice and trip plan.',
  },
  {
    question: 'What payment options are available for Pune to Bangalore cab bookings?',
    answer: 'We accept payments through UPI, credit/debit cards, digital wallets, and bank transfers for a seamless booking experience.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Bangalore cabs?',
    answer: 'All our vehicles are sanitized before every ride, and our drivers strictly follow hygiene and safety standards to ensure a safe travel experience.',
  },
  {
    question: 'Is customer support available during the Pune to Bangalore cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides 24×7 customer support to assist you throughout your Pune to Bangalore trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Nair',
    feedback: 'Sai Trupti Cabs made our Pune to Bangalore trip super comfortable. The driver was experienced, and the car was very clean and well-maintained.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Menon',
    feedback: 'Excellent long-distance service by Sai Trupti Cabs from Pune to Bangalore. The ride was safe, smooth, and right on time!',
    rating: 5,
  },
];






















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Bangalore Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-bangalore-cab.jpg", // Replace with actual image URL
  "description": "Book cabs from Pune to Bangalore with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8000", // Example price, update if needed
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-bangalore-cab-booking"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Bangalore Cab | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune to Bangalore with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available." 
  />
  <meta 
    name="keywords" 
    content="Pune to Bangalore Cab, Pune to Bangalore Taxi Service, Pune to Bangalore Car Hire, AC Cab Pune to Bangalore, Non AC Cab Pune to Bangalore, Innova Cab Pune to Bangalore, Ertiga Cab Pune to Bangalore, Luxury Cab Pune to Bangalore, Affordable Cab Pune to Bangalore, Pune to Bangalore Outstation Cab, Pune to Bangalore One Way Cab, Pune to Bangalore Drop Cab, Corporate Cab Pune to Bangalore, Wedding Cab Pune to Bangalore, Online Cab Booking Pune to Bangalore" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobangalorecab;